class TextExpandable extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-read-more]');
    this.content = this.querySelector('[data-section-content]');
    this.checkOverflow = this.checkOverflow.bind(this);
  }

  connectedCallback() {
    if (this.button && this.content) {
      this.button.addEventListener('click', this.toggle.bind(this));
      requestAnimationFrame(this.checkOverflow);
      this.resizeObserver = new ResizeObserver(this.checkOverflow);
      this.resizeObserver.observe(this.content);
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  checkOverflow() {
    if (this.content.classList.contains('truncated')) {
      const isOverflowing = this.content.scrollHeight > this.content.clientHeight;
      this.button.style.display = isOverflowing ? 'inline-block' : 'none';
    }
  }

  toggle() {
    const isTruncated = this.content.classList.toggle('truncated');
    this.button.textContent = isTruncated ? this.button.dataset.readMoreLabel : this.button.dataset.readLessLabel;
    this.button.setAttribute('aria-expanded', !isTruncated);
  }
}

if (!customElements.get('text-expandable')) {
  customElements.define('text-expandable', TextExpandable);
}